// A dashboard gadget's filters with the dashboard's applied on top (its
// default and selected quick filters as scope, its pinned fields' values as
// run-time filters), as a report gadget inherits its report's (see
// ReportGadgetProvider). A gadget that ignores the dashboard's filters keeps
// only its own.
//
// Unlike on a report gadget, isDefaultFiltersDisabled doesn't opt a gadget
// out: on dashboard gadgets it has only ever meant "skip the dataset's default
// filters", and existing gadgets set it for that reason alone.
const mergeDashboardFilters = ({
  dashboardFilters,
  gadget,
}: {
  dashboardFilters: {
    appliedScope: FilterPlateType[];
    drillDowns: FilterPlateType[];
  };
  gadget: Pick<
    DashboardGadget,
    'scope' | 'drillDowns' | 'isDashboardFiltersIgnored'
  >;
}): { scope: FilterPlateType[]; drillDowns: FilterPlateType[] } => {
  const scope = gadget.scope ?? [];
  const drillDowns = gadget.drillDowns ?? [];
  if (gadget.isDashboardFiltersIgnored) {
    return { scope, drillDowns };
  }

  return {
    scope: [...dashboardFilters.appliedScope, ...scope],
    drillDowns: [...dashboardFilters.drillDowns, ...drillDowns],
  };
};

export default mergeDashboardFilters;
